var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader page-loader-logo"},[(_vm.logo)?_c('img',{attrs:{"alt":"Logo","src":_vm.logo,"width":"100"}}):_vm._e(),(_vm.message)?_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),_c('div',{staticClass:"spinner",class:_vm.spinnerClass || 'spinner-primary'})])
}
var staticRenderFns = []

export { render, staticRenderFns }